import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  AddAreaaInDatabase,
  AddDeputyAllotementInDataBase,
  AddGeoIntervalInDataBase,
  AddStaff,
  Update__GeoIntervalInDataBase,
} from "../../CrudOperations/PostOperation";
import {
  getAllArea,
  getDistrictList,
  getEventList,
  getStaffSkillList,
  getStateList,
} from "../../CrudOperations/GetOperation";
import { updateDutyAllotementInDatabase } from "../../CrudOperations/Update&Edit";
import { Alert } from "bootstrap";

const AddGeoTag = ({ closeModal, onSubmit, alloteDuty, onUpdate }) => {

  console.log(alloteDuty);
  
  const [EventDetailsId, setEventDetailsId] = useState(
    alloteDuty ? alloteDuty.EventDetailsId : ""
  );
  const [IntervalInMinutes, setIntervalInMinutes] = useState(
    alloteDuty ? alloteDuty.IntervalInMinutes : ""
  );
  const [Status, setStatus] = useState(alloteDuty ? alloteDuty.Status : "");

  const [EventDetailsList, setEventDetailsList] = useState([]);

  useEffect(() => {
    const fetchStaffs = async () => {
      const [GetEventDetailsListResonnse] = await Promise.all([getEventList()]);

      console.log(GetEventDetailsListResonnse);

      if (GetEventDetailsListResonnse.data.Message === "Success") {
        setEventDetailsList(GetEventDetailsListResonnse.data.Data);
      }
    };
    fetchStaffs();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    console.log(EventDetailsId);
    console.log(IntervalInMinutes);
    console.log(Status);

    if (!alloteDuty) {
      const response = await AddGeoIntervalInDataBase(
        IntervalInMinutes,
        EventDetailsId,
        Status
      );
      console.log(response);

      if (
        response?.data?.ServerMessage ===
        "GeoTagGenerationRequest added successfully."
      ) {
        onSubmit(); // Handle new data
      } else {
        toast.error(response?.data?.ServerMessage);
      }
    } else {
      const response = await Update__GeoIntervalInDataBase(
        alloteDuty.Id,
        IntervalInMinutes,
        EventDetailsId,
        Status
      );
      console.log(response);

      if (
        response?.data?.Message === "GeoTagGenerationRequest updated successfully"
      ) {
        onSubmit(); // Handle new data
      } else {
        toast.error(response?.data?.ServerMessage);
      }
    }
  };

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 ${"block"}`}
    >
      <div className="bg-white rounded-lg p-4 w-1/3 shadow-lg">
        <h2 className="text-lg font-bold mb-3">
          {alloteDuty ? "Edit Interval" : "Add Geo Interval"}
        </h2>
        <form onSubmit={handleFormSubmit}>
          {console.log(EventDetailsList)}

          <div className="mb-2">
            <label className="block text-gray-700">Event Name*</label>

            <select
              value={EventDetailsId}
              onChange={(e) => setEventDetailsId(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
            >
              <option value="">Select Event</option>
              {EventDetailsList?.length > 0 &&
                EventDetailsList.map((evDetails) => (
                  <option
                    key={evDetails.EventDetailId}
                    value={evDetails.EventDetailId}
                  >
                    {evDetails.EventName}
                  </option>
                ))}
            </select>
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">Interval Time *</label>
            <input
              type="number"
              value={IntervalInMinutes}
              onChange={(e) => setIntervalInMinutes(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
              placeholder="Enter time in minutes"
              min={1}
            />
          </div>

          <div className="mb-2">
            <label className="block text-gray-700">Status*</label>

            <select
              value={Status}
              onChange={(e) => setStatus(e.target.value)}
              className="border border-gray-300 p-1 w-full rounded-md"
            >
              <option value="">Select Event</option>
              <option key={1} value={1}>
                Active
              </option>

              <option key={0} value={0}>
                InActive
              </option>
            </select>
          </div>

          <div className="flex justify-end">
            <button
              type="button"
              onClick={closeModal}
              className="bg-gray-300 px-3 py-1 rounded-md mr-2"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="bg-blue-600 text-white px-3 py-1 rounded-md"
            >
              {alloteDuty ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddGeoTag;
